export const UNO_URL = "https://api.simulanis.io";
// export const UNO_URL = 'https://metaverse.hpcl.co.in:3003';       // For HPCL
// export const UNO_URL = 'https://simulanis-uno-backend-backup-uat.azurewebsites.net';
// export const UNO_URL = "http://localhost:3003";
// export const UNO_URL = 'https://usermanagement-behcg9a8d0fdgbfn.centralindia-01.azurewebsites.net';
export const applicationId = "f17efe60-eee0-422f-94e4-210e233af1c9";
export const defaultLogo = "https://cdn.simulanis.io/sso/logos/default_simulanis.png";
